import { ActivityIndicator, KeyboardAvoidingView, Platform, Pressable, useWindowDimensions, View, VirtualizedList, ScrollView } from 'react-native'
import React, { Dispatch, SetStateAction, useEffect, useMemo, useRef, useState } from 'react'
import { FormikProps } from 'formik'
import { optionRes, ProductFormValues } from "../productModule"
import { ZenBadge, ZenButton, ZenCheckBox, ZenDivider, ZenDropdown, ZenIcon, ZenInput, ZenSwitch, ZenText, ZenToast, ZenToolTip } from 'zen-core-elements'
import { TouchableOpacity } from 'react-native'
import { Image } from 'react-native'
import { ThemeConsumer } from '@rneui/themed'
import { DropdownRenderItemInterface, ItemTypeValue } from 'zen-core-elements/src/elements/zenDropdown/dropdownPicker'
import Popover from 'react-native-popover-view'
import CommonDialogBox from '../../../../shared/commonComponents/commonDialogBox'
import { useAppDispatch } from '../../../../redux/hooks'
import { checkDuplicatesRedux } from '../../../../redux/slices/commonSlice'
import { config } from '../../../../shared/environment'
import CommonImageUpload, { commonPickerRes } from '../../../../shared/commonComponents/commonImageUpload'
import { CustomModal } from '../../../../shared/commonComponents/customModal'
import { appColors } from '../../../../themes/appTheme'
import { ZenRBSheetRef } from 'zen-core-elements/src/elements/zenRBSheet/RBSheet'
import ProductBarcodeGenerator from './productBarcodeGenerator'

interface DummyVariantsProps {
    formik: FormikProps<ProductFormValues>
    variants: { label: string, value: number }[]
    selectedVarObj: { label?: string, value: number }[],
    setSelectedVarObj: Dispatch<SetStateAction<{ label?: string, value: number }[]>>
    multiTextArray: string[]
    checked: { [Key: string]: { id?: string, checked?: boolean } }[],
    setChecked: Dispatch<SetStateAction<{ [Key: string]: { id?: string, checked?: boolean } }[]>>
    locationOptions: { label: string, value: number }[]
    dimensionOptions: ItemTypeValue[]
    // Needed to resolve the category / brand names used by the auto SKU tokens
    categoryOptions: ItemTypeValue[]
    brandOptions: ItemTypeValue[]
    // venderDropdownData: ItemTypeValue[]
    productId: number | undefined
    defLoc: number
    isProductWrite: boolean
    setRemoveVarId: Dispatch<SetStateAction<number[]>>
    multiVariants: string[]
    setMultiVariants: Dispatch<SetStateAction<string[]>>
    varRes: optionRes['result']
    getCombn: (val: { id: number | string, label: string }[][]) => {
        id: number | string;
        label: string;
    }[]
    imgUploading: boolean,
    setImgUploading: Dispatch<SetStateAction<boolean>>
}
const ProductVariant = ({ formik, variants, selectedVarObj, setSelectedVarObj, checked, setChecked, dimensionOptions, categoryOptions, brandOptions, locationOptions, productId, defLoc, isProductWrite, setRemoveVarId, multiVariants, setMultiVariants, varRes, getCombn, imgUploading, setImgUploading }: DummyVariantsProps) => {
    const storeId = config.storeId
    const dispatch = useAppDispatch()
    const [variantCollapseState, setVariantCollapseState] = useState<Record<string, boolean>>({});

    const bottomRef = useRef<ZenRBSheetRef>(null)

    const { width } = useWindowDimensions()

    // Variable which is used to check no image 
    const [noImage, setNoImage] = useState(true);

    //Variable which is used to Store the current variant selected
    const [current, setCurrent] = useState("")


    // Variable which is used to check duplicate SKU
    const [isDuplicateValue, setIsDuplicateValue] = useState(false)

    //Variable which is used to set SKU value
    const [Sku, setSku] = useState('')

    // Category / brand names feeding the auto SKU tokens, resolved from the ids
    // held on the parent product form.
    const skuCategoryName = useMemo(() => {
        const firstId = formik?.values?.categories?.[0]
        if (firstId === undefined || firstId === null) return ''
        return categoryOptions?.find((option) => option?.value === firstId)?.label ?? ''
    }, [formik?.values?.categories, categoryOptions])

    const skuBrandName = useMemo(() => {
        const brandId = formik?.values?.brand
        if (brandId === undefined || brandId === null) return ''
        return brandOptions?.find((option) => option?.value === brandId)?.label ?? ''
    }, [formik?.values?.brand, brandOptions])

    // Variable to handle the variants bottom sheet
    const [openChoseVariants, setOpenChoseVariants] = useState(false)
    // Variable which is used to store variant open status
    const [varOpen, setVarOpen] = useState(false)
    //Variable used to handle change variants item props
    const [variantsItemProps, setVariantsItemProps] = useState<DropdownRenderItemInterface>()
    //Variable used to handle delete variant dialog
    const [isDelVar, setIsDelVar] = useState(false)
    //Variable used to handle variant modification state
    const [isModifyPopover, setIsModifyPopover] = useState(false)
    //Variable used to hold name for remove variant
    const [delName, setDelName] = useState('')
    // Variable used to store remove variant id
    const [removeId, setRemoveId] = useState<number>()

    //Variable used to handle leave page dialog
    const [isLeavePopover, setIsLeavePopover] = useState(false)



    useEffect(() => {
        setVariantCollapseState(prev => {
            const next: Record<string, boolean> = {}
            Object.keys(formik.values.varCombinations).forEach(key => {
                next[key] = prev[key] ?? false;
            });
            return next;
        });
    }, [Object.keys(formik.values.varCombinations || {}).join(",")]);

    //Function used to handle the image picker actions
    const handleImage = (name: string, res?: commonPickerRes[]) => {
        switch (name) {
            case 'Camera':
            case 'Library':
            case 'StoreImageGallery':
            case 'ZenbasketGallery':
                if (res && res.length > 0) {
                    const newImages = res.map((response) => ({
                        imgKey: response?.key || "",
                        uploadCompleted: true,
                        uploadLoader: false,
                    }))
                    formik.setFieldValue(`varCombinations.${current}.varImages`, [
                        ...(formik.values?.varCombinations?.[current]?.varImages || []),
                        ...newImages
                    ])
                    setNoImage(false)
                }
                break;
            case 'Cancel':
                break;
        }
    }

    //Function to check duplicate Sku
    const checkIsDuplicateSKU = (text: string, vid: number | null) => {
        const data = {
            "value": text,
            "tableName": "variantCombinationDetails",
            "columnName": "sku",
            "id": vid ? vid : 0,
            "storeId": true,
        }
        dispatch(checkDuplicatesRedux({ data, storeId: storeId })).unwrap().then((res) => {
            if (res?.success) {
                if (res?.result?.alreadyExists) {
                    setIsDuplicateValue(true)
                }
                else {
                    setIsDuplicateValue(false)
                    Object.keys(formik.values?.varCombinations).map((item) => {
                        if (text != "" && text == formik.values?.varCombinations[item]?.SKU && item != current) {
                            setIsDuplicateValue(true)
                        }
                    })
                }
            }
        }).catch((err) => {
            setIsDuplicateValue(false)
            Object.keys(formik.values?.varCombinations).map((item) => {
                if (text != "" && text == formik.values?.varCombinations[item]?.SKU && item != current) {
                    setIsDuplicateValue(true)
                }
            })
            console.log(err)
        })
    }

    //Function used to add location
    const addLocation = (item: string, index: number) => {
        let newArr = [...(formik.values?.varCombinations?.[item]?.locArr ?? [])];
        newArr.push({
            stock: "",
            threshold: "",
            selectedLoc: "",
            locationOpen: false,
            isInfinite: true,
        })
        formik.setFieldValue(`varCombinations.${item}.locArr`, newArr);
    }

    //Function used to remove the combination
    const removeLocation = (item: string, index: number) => {
        let newArr = [...(formik.values?.varCombinations?.[item]?.locArr ?? [])];
        newArr.splice(index, 1)
        formik.setFieldValue(`varCombinations.${item}.locArr`, newArr);
    }



    //Debounce for SKU
    useEffect(() => {
        if (Sku != '') {
            const duplicateSkuDebounceFunction = setTimeout(() => {
                checkIsDuplicateSKU(Sku, formik.values?.varCombinations?.[current]?.vid ? formik.values?.varCombinations?.[current]?.vid : null)
            }, 1000);
            return () => clearTimeout(duplicateSkuDebounceFunction);
        }
        else {
            setIsDuplicateValue(false)
        }
    }, [Sku]);

    // Sync selectedVarObj when formik.values.selectedVariants is populated (e.g. edit mode or initial load)
    useEffect(() => {
        if (formik.values?.selectedVariants?.length && selectedVarObj.length === 0 && variants?.length) {
            const initialSelectedVarObj = variants
                ?.filter((variant) => formik.values.selectedVariants?.includes(variant.value))
                .map((variant) => ({ label: variant.label, value: variant.value })) ?? [];
            if (initialSelectedVarObj.length > 0) {
                setSelectedVarObj(initialSelectedVarObj);
            }
        }
    }, [formik.values?.selectedVariants, variants]);

    //For invoking function for generating combinations
    useEffect(() => {
        if (selectedVarObj.length > 0) {
            let options: { id: number, label: string }[][] = [];

            selectedVarObj
                .sort((a, b) => a.value - b.value)
                .forEach(svar => {
                    const val = varRes?.find(i => i.id === svar.value);
                    if (val) {
                        const values = val.optionValues.map(v => ({
                            id: v.id,
                            label: v.optionValue
                        }));
                        options.push(values);
                    }
                });

            let combCount = options.reduce((total, list) => total * list.length, 1);

            let varCombns: { id: string | number, label: string }[] = [];
            if (combCount <= 600) {
                varCombns = getCombn(options);
            } else {
                ZenToast({ message: "Your combination reached the maximum limit, Please choose some other options", type: "error" });
            }

            const existingCheckedMap = new Map<string, boolean>();
            if (formik.values?.varCombinations && Object.keys(formik.values.varCombinations).length > 0) {
                Object.keys(formik.values.varCombinations).forEach(key => {
                    existingCheckedMap.set(key.split(',').sort().join(','), true);
                });
            }

            const combo = varCombns.map(item => {
                const normalizedLabel = item.label?.split(',')?.sort()?.join(',');
                const isChecked = existingCheckedMap.get(normalizedLabel) ?? false;
                return {
                    [item.label]: { id: item.id as string, checked: isChecked }
                };
            });

            setChecked(combo);
        } else {
            setChecked([]);
        }
    }, [selectedVarObj, varRes]);

    //Function used to modify combination object
    const addCombo = () => {
        let varValue = { ...formik.values?.varCombinations }

        const touched = { ...formik.touched };
        const errors = { ...formik.errors };
        const varCombinationsTouched = touched.varCombinations ? { ...touched.varCombinations } : {};
        const varCombinationsErrors = errors.varCombinations ? { ...errors.varCombinations } : {};
        let touchedUpdated = false;
        let errorsUpdated = false;

        checked?.map(i => {
            const keyName = Object?.keys(i)[0];
            if (!keyName) return;
            let val = keyName.split(',')?.sort()?.join(',')
            let found = Object?.keys(varValue)?.some(key => key?.split(',')?.sort()?.join(',') === val)

            if (Object?.values(i)[0]?.checked && !found) {
                let valueIds: number[] = []
                if (typeof (Object?.values(i)[0].id) === "number") {
                    valueIds.push(parseInt(Object?.values(i)[0]?.id as string))
                } else {
                    valueIds = (Object?.values(i)[0]?.id as string)?.split(',').map(Number)
                }

                varValue[keyName] = {
                    removedVariantImagesUrl: [],
                    isSellOnline: false,
                    isSellPos: true,
                    isDefault: false, // Temporarily set to false
                    locArr: [{
                        stock: "",
                        threshold: "",
                        selectedLoc: defLoc,
                        isInfinite: true,
                    }],
                    selectedWunit: "",
                    selectedDunit: "",
                    weightOpen: false,
                    dimensionOpen: false,
                    width: '',
                    weight: '',
                    height: '',
                    length: '',
                    SKU: '',
                    UPC: '',
                    taxCode: 'P000000',
                    sellingPrice: '',
                    MRP: '',
                    SquareId: '',
                    WholesalePrice: '',
                    costPrice: '',
                    CustomLabel: '',
                    weightCount: '',
                    varImages: [],
                    valueId: valueIds,
                    variantAvailability: true
                }

                if ((varCombinationsTouched as any)[keyName]) {
                    delete (varCombinationsTouched as any)[keyName];
                    touchedUpdated = true;
                }
                if ((varCombinationsErrors as any)[keyName]) {
                    delete (varCombinationsErrors as any)[keyName];
                    errorsUpdated = true;
                }
            } else if (found && !Object?.values(i)[0]?.checked) {
                for (let key in varValue) {
                    if (key?.split(',')?.sort()?.join(',') === val) {
                        delete varValue[key]
                        if ((varCombinationsTouched as any)[key]) {
                            delete (varCombinationsTouched as any)[key];
                            touchedUpdated = true;
                        }
                        if ((varCombinationsErrors as any)[key]) {
                            delete (varCombinationsErrors as any)[key];
                            errorsUpdated = true;
                        }
                    }
                }
            }
        })

        // Ensure only the first item gets isDefault: true
        const keys = Object.keys(varValue)
        keys.forEach((key, index) => {
            varValue[key].isDefault = index === 0
        })

        formik.setFieldValue("varCombinations", varValue)

        if (touchedUpdated) {
            touched.varCombinations = varCombinationsTouched;
            formik.setTouched(touched, false);
        }
        if (errorsUpdated) {
            errors.varCombinations = varCombinationsErrors;
            formik.setErrors(errors);
        }

        setOpenChoseVariants(false)
    }

    //Function to be called while changing variants dropdown value
    const onChangeVariants = (itemProps: DropdownRenderItemInterface) => {
        const value = itemProps?.item?.value as number;

        // Step 1: Initialize selectedVarObj on edit
        let updatedSelectedVarObj = [...selectedVarObj];
        let updatedSelectedVar = [...(formik.values.selectedVariants ?? [])];

        if (formik.values?.selectedVariants!?.length > 0 && selectedVarObj.length === 0) {
            updatedSelectedVarObj = variants
                ?.filter((variant) => formik.values.selectedVariants?.includes(variant.value))
                .map((variant) => ({ label: variant.label, value: variant.value })) ?? [];
        }

        // Step 2: Toggle selection
        if (updatedSelectedVar.includes(value)) {
            updatedSelectedVar = updatedSelectedVar.filter((v) => v !== value);
            updatedSelectedVarObj = updatedSelectedVarObj.filter((obj) => obj.value !== value);
        } else {
            updatedSelectedVar.push(value);
            updatedSelectedVarObj.push({ label: itemProps.item.label, value });
        }
        formik.setFieldValue("selectedVariants", updatedSelectedVar)
        setSelectedVarObj(updatedSelectedVarObj);

        // Step 3: Build unique label list for setMultiVariants
        const labelSet = new Set<string>();
        variants?.forEach((variant) => {
            if (updatedSelectedVar.includes(variant.value)) {
                labelSet.add(variant.label);
            }
        });

        setMultiVariants(Array.from(labelSet));
    };


    //Variable used to handle variant modification confirmation
    const varModifyProps = {
        content: 'Are you sure you want to modify the selected options because it will affect the existing variant combination?',
        button: [
            { id: 2, name: 'Yes', },
            { id: 1, name: 'No', },
        ],
        image: {
            iconName: 'information-outline',
            color: appColors.primary
        }
    }

    // isInFbt must be strictly decalared above only
    const delVarProps = {
        content: "Are you sure you want to remove this variant?",
        button: [
            { id: 2, name: 'Yes', },
            { id: 1, name: 'No', },
        ],
        image: {
            iconName: 'delete-outline',
            color: appColors.inActiveColor
        }
    }

    //Function used to remove the combination
    const removeCombo = (name: string) => {
        const varCombinations = { ...formik.values.varCombinations };

        // Check if the variant to be deleted was default
        const wasDefault = varCombinations?.[name]?.isDefault;

        // Delete the variant
        delete varCombinations[name];

        // If the deleted one was default and there’s at least one left
        if (wasDefault && Object.keys(varCombinations).length > 0) {
            const firstKey = Object.keys(varCombinations)[0];
            varCombinations[firstKey].isDefault = true;
            formik.setFieldValue(`varCombinations.${firstKey}.isDefault`, true);
        }

        // Update the full varCombinations object
        formik.setFieldValue('varCombinations', varCombinations);

        // Clean up touched and errors in formik for this variant combination
        const touched = { ...formik.touched };
        if (touched.varCombinations) {
            const varCombinationsTouched = { ...touched.varCombinations };
            delete (varCombinationsTouched as any)[name];
            touched.varCombinations = varCombinationsTouched;
            formik.setTouched(touched, false);
        }

        const errors = { ...formik.errors };
        if (errors.varCombinations) {
            const varCombinationsErrors = { ...errors.varCombinations };
            delete (varCombinationsErrors as any)[name];
            errors.varCombinations = varCombinationsErrors;
            formik.setErrors(errors);
        }

        setChecked((prev) => {
            let temp = [...prev]
            temp.map((com) => {
                if (Object?.keys(com)[0] == name) {
                    com[Object?.keys(com)[0]].checked = false
                }
            })
            return temp
        })
        if (productId) {
            setRemoveVarId((prev) => {
                if (typeof (removeId) != 'undefined') {
                    return [...prev, removeId]
                }
                else {
                    return [...prev]
                }
            })
        }
    }
    const confirmation = (value: { id: number, name: string }) => {

        if (isModifyPopover && value?.name == 'Yes') {
            setIsModifyPopover(false)
            ZenToast({ message: "Existing variants removed successfully", type: "success" })
            if (productId) {
                const rids = Object.values(formik.values?.varCombinations || {})
                    .map(obj => obj?.vid)
                    .filter((vid): vid is number => typeof vid === 'number' && !isNaN(vid));
                if (rids.length > 0) {
                    setRemoveVarId(prev => [...prev, ...rids]);
                }
            }
            formik.setFieldValue("varCombinations", {});
            const touched = { ...formik.touched };
            if (touched.varCombinations) {
                delete touched.varCombinations;
                formik.setTouched(touched, false);
            }
            const errors = { ...formik.errors };
            if (errors.varCombinations) {
                delete errors.varCombinations;
                formik.setErrors(errors);
            }
            setChecked([]);
            setVariantCollapseState({});
            setCurrent("");
            setSku("");
            setIsDuplicateValue(false);
            if (variantsItemProps) {
                onChangeVariants(variantsItemProps);
                setVariantsItemProps(undefined);
            }
        }
        else if (isModifyPopover && value?.name == 'No') {
            setIsModifyPopover(false)
        }
        else if (isDelVar && value?.name === 'Yes') {
            removeCombo(delName)
            ZenToast({ message: "Variant removed successfully", type: "success" })
            setIsDelVar(false)
        }
        else if (isDelVar && value?.name === 'No') {
            setIsDelVar(false)
        }
        if (!isModifyPopover && !isDelVar && value.name === 'Stay') {
            setIsLeavePopover(false)
        }
        else {
            setIsLeavePopover(false)
            setTimeout(() => {
                // setCurrentOpenAccordion(prev => {
                //                                         prev[index].isOpen=false
                //                                         return prev
                //                                     } )
            }, 1000)

        }
    }
    const renderItem = ({ item, index }: {
        item: { [Key: string]: { id?: string, checked?: boolean } }[],
        index: number
    }) => {
        return (
            item?.map((data) => {
                return (
                    <ThemeConsumer key={index}>
                        {({ theme }) => (
                            <ZenCheckBox
                                disabled={!isProductWrite}
                                onPress={() => {
                                    setChecked((prev) => {
                                        let temp = [...prev];
                                        const key = Object.keys(temp[index])[0]; // ✅ Fix is here
                                        temp[index][key]["checked"] = !temp[index][key]["checked"];
                                        return temp;
                                    });
                                }}

                                titleStyle={theme?.addEditProductStyle.variantCheckboxTitle}
                                title={Object?.keys(data)[0]}
                                containerStyle={theme?.addEditProductStyle.variantCheckboxContainer}
                                checked={Object?.values(data)[0]?.checked as boolean}
                                checkedColor={theme.primary}

                            />
                        )}
                    </ThemeConsumer>
                )
            })

        )
    }

    const sortedVarKeys = Object.keys(formik.values?.varCombinations || {}).sort(
        (a, b) => {
            const aIsDefault = formik.values.varCombinations[a]?.isDefault;
            const bIsDefault = formik.values.varCombinations[b]?.isDefault;

            // true should come first
            return Number(bIsDefault) - Number(aIsDefault);
        }
    );

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <KeyboardAvoidingView style={[theme?.addEditProductStyle.flex]}>
                    {/* Variants Section */}
                    {formik?.values.isMultiVariants ? (<View style={{ flex: 1 }}>
                        <ScrollView showsVerticalScrollIndicator={false} style={theme.addEditProductStyle.flex} >
                            <View style={theme.addEditProductStyle.modifierVariantHeader}>
                                <ZenText
                                    content={`Select options to create variant for this product`}
                                    style={[theme.addEditProductStyle.modifierVariantHeaderText, { fontSize: theme?.mediumFontSize }]}
                                    color={theme.lightDark}
                                    bold
                                />
                                <View style={[theme.addEditProductStyle.variantFlexdirection, { justifyContent: 'space-between', zIndex: 2 }]}>
                                    <ZenDropdown
                                        placeholder="Product options"
                                        disabled={!isProductWrite}
                                        searchable
                                        value={formik.values.selectedVariants}
                                        setValue={() => { }}
                                        items={variants}
                                        open={varOpen}
                                        setOpen={setVarOpen}
                                        multiple={true}
                                        multipleText={multiVariants ? multiVariants?.length > 4 ? multiVariants?.slice(0, 4).concat('....').toString() : multiVariants?.toString() : ''}
                                        renderListItem={itemProps => {
                                            return (
                                                <TouchableOpacity onPress={() => {
                                                    if (Object.keys(formik.values?.varCombinations).length != 0) {
                                                        setVariantsItemProps(itemProps)
                                                        setIsModifyPopover(true)
                                                    } else {
                                                        onChangeVariants(itemProps)
                                                    }
                                                }} style={{ flexDirection: 'row', justifyContent: 'space-between', padding: 10 }}>
                                                    <ZenText content={itemProps?.item?.label} size={theme.mediumFontSize} bold={itemProps.isSelected} color={itemProps.isSelected ? theme.primary : theme.lightDark} />
                                                    {itemProps.isSelected && (
                                                        <ZenIcon
                                                            size={20}
                                                            name="check"
                                                            type="entypo"
                                                            color={theme.primary}

                                                        />
                                                    )}
                                                </TouchableOpacity>
                                            );
                                        }}
                                        zIndex={5}
                                        style={{ zIndex: 5 }}
                                        containerStyle={{ marginVertical: 5 }}
                                        mainContainerStyle={{ flex: formik.values.selectedVariants?.length ? width > 600 ? 0.85 : 0.75 : 1 }}
                                        maxHeight={120}
                                        dropDownContainerStyle={theme?.addEditProductStyle.dropDownContainer}
                                    />
                                    {
                                        formik.values.selectedVariants?.length && isProductWrite ?
                                            <ZenButton
                                                title={width > 600 ? "Add Variants" : "Add"}
                                                buttonStyle={theme.addEditProductStyle.variantButtonStyle}
                                                containerStyle={{ flex: width > 600 ? 0.15 : 0.25 }}
                                                titleStyle={[theme.addEditProductStyle.titleStyle, { color: theme?.light }]}
                                                onPress={() => {
                                                    setVarOpen(false);
                                                    setOpenChoseVariants(true)
                                                }}
                                                disabled={checked?.length ? false : true}
                                            />
                                            : null
                                    }
                                </View>
                            </View>
                            {
                                Object.keys(formik.values?.varCombinations)?.length ? (
                                    sortedVarKeys.map((item, index) => (
                                        <View key={index} style={[theme.addEditProductStyle.modifierVariantHeader, { padding: 15 }]}>
                                            <Pressable
                                                style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: "center", paddingTop: width > 600 ? 10 : 7 }}
                                                onPress={() => {
                                                    setVariantCollapseState(prev => ({
                                                        ...prev,
                                                        [item]: !prev[item]
                                                    }));

                                                    setCurrent(item)
                                                }}
                                            >
                                                <ZenText
                                                    content={item}
                                                    key={index}
                                                    style={theme?.addEditProductStyle.mediumText}
                                                    bold
                                                    color={theme.primary} />
                                                <View style={theme?.addEditProductStyle.variantHeaderRight}>
                                                    {
                                                        (formik?.values.varCombinations[item]?.isDefault) &&
                                                        <ZenBadge
                                                            badgeName={'Default Value'}
                                                            badgeColor={theme?.lightYellow}
                                                            badgeTextColor={theme?.lightDark}
                                                            badgeTextStyle={{ fontFamily: theme.bold, fontSize: theme?.badgeFontSize }}
                                                            badgeContainerStyle={theme?.addEditProductStyle.badgeContainer}
                                                        />
                                                    }
                                                    {isProductWrite && <ZenIcon name={'delete'} type={"material-community"} size={25} color={'#d72c0c'} style={theme?.addEditProductStyle.marginHorizontal6}
                                                        onPress={() => {
                                                            setIsDelVar(true)
                                                            setDelName(item)
                                                            if (productId) {
                                                                setRemoveId(formik.values?.varCombinations?.[item].vid)
                                                            }
                                                        }} />}
                                                    <ZenIcon name={variantCollapseState?.[item] ? "arrow-up" : 'arrow-down'} type={"simple-line-icon"} size={25} color={theme.grey} style={theme?.addEditProductStyle.marginHorizontal6} />
                                                </View>
                                            </Pressable>
                                            {
                                                variantCollapseState?.[item] &&
                                                <KeyboardAvoidingView behavior={Platform.OS === "ios" ? "padding" : undefined} style={[theme?.addEditProductStyle.rootBackground, theme?.addEditProductStyle.paddingVertical20]} enabled>

                                                    <View style={{ flex: 1 }}>
                                                        <View pointerEvents={!isProductWrite ? "box-only" : undefined}>
                                                            <View style={[{ flexDirection: width > 600 ? 'row' : "column" }, theme?.addEditProductStyle.variantDetailsHeader]}>
                                                                <ZenText content="Variant Details" style={{ fontSize: theme?.smallerFontSize }} color={theme.lightDark} />
                                                                <View style={{ flexDirection: width > 600 ? 'row' : 'column', paddingRight: width > 600 ? 10 : undefined, alignSelf: width > 600 ? "flex-end" : undefined, columnGap: 10, }}>
                                                                    <Pressable disabled={!isProductWrite} style={{ flexDirection: 'row', alignItems: "center" }} onPress={() => {
                                                                        const updatedVarCombinations = Object.entries(formik.values.varCombinations).reduce(
                                                                            (acc, [key, value]) => {
                                                                                acc[key] = {
                                                                                    ...value,
                                                                                    isDefault: key === item, // true for selected item, false for all others
                                                                                };
                                                                                return acc;
                                                                            },
                                                                            {} as typeof formik.values.varCombinations
                                                                        );

                                                                        formik.setFieldValue("varCombinations", updatedVarCombinations);
                                                                    }}>
                                                                        <ZenSwitch
                                                                            activeColor={theme?.primary}
                                                                            activeThumbColor={theme?.light}
                                                                            inActiveColor={theme?.borderColor}
                                                                            inactiveThumbColor={theme?.light}
                                                                            disabled={formik?.values.varCombinations[item]?.isDefault || !isProductWrite}
                                                                            value={formik?.values.varCombinations[item]?.isDefault}
                                                                            onValueChange={() => {
                                                                                const updatedVarCombinations = Object.entries(formik.values.varCombinations).reduce(
                                                                                    (acc, [key, value]) => {
                                                                                        acc[key] = {
                                                                                            ...value,
                                                                                            isDefault: key === item, // true for selected item, false for all others
                                                                                        };
                                                                                        return acc;
                                                                                    },
                                                                                    {} as typeof formik.values.varCombinations
                                                                                );

                                                                                formik.setFieldValue("varCombinations", updatedVarCombinations);
                                                                            }}

                                                                            style={{ transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }] }} />
                                                                        <ZenText style={{ fontSize: theme?.smallHeaderFontSize }} content="Make as default variant" />
                                                                    </Pressable>
                                                                    {/* <Pressable disabled={!isProductWrite} style={{ flexDirection: 'row', alignItems: "center" }} onPress={() => formik.setFieldValue(`varCombinations.${item}.isSellOnline`, !formik?.values.varCombinations[item]?.isSellOnline)} >
                                                                        <ZenSwitch
                                                                            activeColor={theme?.primary}
                                                                            disabled={!isProductWrite}
                                                                            activeThumbColor={theme?.light}
                                                                            inActiveColor={theme?.borderColor}
                                                                            inactiveThumbColor={theme?.light}
                                                                            value={formik?.values.varCombinations[item]?.isSellOnline}
                                                                            onValueChange={() => {
                                                                                formik.setFieldValue(`varCombinations.${item}.isSellOnline`, !formik?.values.varCombinations[item]?.isSellOnline)
                                                                            }}
                                                                            style={{ transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }], }} />
                                                                        <ZenText style={{ fontSize: theme?.smallHeaderFontSize }} content="Sell Online" />
                                                                    </Pressable> */}
                                                                    <Pressable disabled={!isProductWrite} style={{ flexDirection: 'row', alignItems: "center" }} onPress={() => formik.setFieldValue(`varCombinations.${item}.isSellPos`, !formik?.values.varCombinations[item]?.isSellPos)}>
                                                                        <ZenSwitch
                                                                            activeColor={theme?.primary}
                                                                            activeThumbColor={theme?.light}
                                                                            disabled={!isProductWrite}
                                                                            inActiveColor={theme?.borderColor}
                                                                            inactiveThumbColor={theme?.light}
                                                                            value={formik?.values.varCombinations[item]?.isSellPos}
                                                                            onValueChange={() => {
                                                                                formik.setFieldValue(`varCombinations.${item}.isSellPos`, !formik?.values.varCombinations[item]?.isSellPos)
                                                                            }}
                                                                            style={{ transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }], }} />
                                                                        <ZenText style={{ fontSize: theme?.smallHeaderFontSize }} content="Sell POS" />
                                                                    </Pressable>
                                                                </View>
                                                            </View>
                                                            <View style={[theme.addEditProductStyle.variantFlexdirection, { columnGap: 15, flex: 1, flexDirection: width > 600 ? 'row' : 'column' }]}>
                                                                <View style={[{ flex: 0.5, marginBottom: 10 }]}>
                                                                    <View style={[{ rowGap: 10, borderRadius: 12, borderWidth: 1, borderColor: theme?.borderColor, padding: 10, flex: 1 }]}>
                                                                        <View style={{ flexDirection: 'row', justifyContent: "space-between" }}>
                                                                            <ZenText content={"Variant Image"} size={theme?.smallFontSize} color={theme?.primary} />
                                                                        </View>
                                                                        <View
                                                                            style={[theme?.addEditProductStyle.imageUploadContainer, ((formik?.values?.varCombinations?.[current]?.varImages ? formik?.values?.varCombinations?.[current]?.varImages : [])?.length < 5 ? theme?.addEditProductStyle.centerItems : {})]}
                                                                        >

                                                                            {
                                                                                (formik?.values?.varCombinations?.[current]?.varImages ? formik?.values?.varCombinations?.[current]?.varImages : [])?.length < 5 &&
                                                                                <Pressable style={theme?.addEditProductStyle.uploadImageButton} disabled={!isProductWrite}
                                                                                    onPress={() => {
                                                                                        setCurrent(item)
                                                                                        bottomRef?.current?.open()
                                                                                    }}
                                                                                >
                                                                                    <ZenIcon name="camera" type="material-community" size={width > 600 ? 30 : 22} color={theme.primary}
                                                                                    />
                                                                                    <ZenText content={"Upload"} color={theme?.primary} size={'small'} />
                                                                                </Pressable>
                                                                            }

                                                                            {(formik?.values?.varCombinations?.[current]?.varImages ? formik?.values?.varCombinations?.[current]?.varImages : [])?.length ? <View style={[theme?.addEditProductStyle.imagesListContainer, {
                                                                                flex: ((formik?.values?.varCombinations?.[item]?.varImages && formik?.values?.varCombinations?.[item]?.varImages.length) ?? 0) > 4 ? 1 : 5 / 6,
                                                                            }]}>
                                                                                {
                                                                                    formik?.values?.varCombinations?.[item]?.varImages?.map((imageItem, imgIndex) => (
                                                                                        <View style={theme?.addEditProductStyle.imageItemContainer} key={imgIndex}>
                                                                                            {isProductWrite && <TouchableOpacity style={theme?.addEditProductStyle.closeIconContainer}>
                                                                                                <ZenIcon type='material-community' name='close-circle' color={theme.lightDark} size={24}
                                                                                                    disabled={imgUploading}
                                                                                                    onPress={() => {
                                                                                                        let updatedItems = [...(formik.values?.varCombinations?.[item]?.varImages ?? [])];
                                                                                                        const index = updatedItems.findIndex(item => item?.imgKey === imageItem?.imgKey);
                                                                                                        if (index !== -1) {
                                                                                                            updatedItems.splice(index, 1);
                                                                                                        }
                                                                                                        if (imageItem?.id !== null) {
                                                                                                            let temp = [...(formik.values?.varCombinations?.[item]?.removedVariantImagesUrl ?? [])];
                                                                                                            temp.push({ id: imageItem?.id })
                                                                                                            formik.setFieldValue(`varCombinations.${item}.removedVariantImagesUrl`, temp);
                                                                                                        }
                                                                                                        formik.setFieldValue(`varCombinations.${item}.varImages`, updatedItems);
                                                                                                    }}
                                                                                                />
                                                                                            </TouchableOpacity>}
                                                                                            <Image
                                                                                                source={{
                                                                                                    uri:
                                                                                                        imageItem?.imgKey
                                                                                                            ? imageItem?.imgKey.includes("file:")
                                                                                                                ? imageItem?.imgKey
                                                                                                                : config.AWSImageUrl + imageItem?.imgKey
                                                                                                            : imageItem?.imgKey
                                                                                                                ? imageItem?.imgKey
                                                                                                                : config.AWSImageUrl + "mobileAdmin/upload.png"
                                                                                                }}
                                                                                                style={{ width: width > 600 ? 60 : 50, height: width > 600 ? 80 : 30, }}
                                                                                            />
                                                                                            <ZenIcon
                                                                                                type="material-community"
                                                                                                name={imageItem?.uploadCompleted ? 'cloud-check' : 'cloud-off-outline'} color={imageItem?.uploadCompleted ? theme.activeColor : theme.lightDark} size={20}
                                                                                                style={theme?.addEditProductStyle.cloudIcon}
                                                                                            />
                                                                                            {imageItem?.uploadLoader && <View style={theme?.addEditProductStyle.overlay} />}
                                                                                            <ActivityIndicator
                                                                                                style={theme?.addEditProductStyle.absoluteFill}
                                                                                                size="large"
                                                                                                color={theme.light}
                                                                                                animating={imageItem?.uploadLoader}
                                                                                            />
                                                                                        </View>
                                                                                    ))
                                                                                }
                                                                            </View> : undefined}
                                                                        </View>
                                                                    </View>
                                                                </View>
                                                                {/* <View style={{ flex: 0.5 }}>
                                                                    <ZenInput
                                                                        type="outlined"
                                                                        label="SKU"
                                                                        disabled={!isProductWrite}
                                                                        labelStyle={theme.addEditProductStyle.labelStyle}
                                                                        value={formik?.values.varCombinations[item]?.SKU}
                                                                        onChangeText={(text: string) => {
                                                                            setSku(text.trim())
                                                                            formik.setFieldValue(`varCombinations.${item}.SKU`, text)
                                                                        }}
                                                                        onBlur={() => {
                                                                            formik.setFieldTouched(`varCombinations.${item}.SKU`, true)
                                                                            formik.setFieldValue(`varCombinations.${item}.SKU`, formik?.values.varCombinations[item]?.SKU?.trim())
                                                                        }}
                                                                        errorMessage={formik?.touched.varCombinations?.[item]?.SKU && formik?.errors.varCombinations?.[item]?.SKU ? formik?.touched.varCombinations[item]?.SKU && formik?.errors.varCombinations[item]?.SKU : isDuplicateValue ? 'SKU already exists' : undefined}
                                                                        errorStyle={theme.addEditProductStyle.errorStyle}
                                                                        inputContainerStyle={{ height: 45 }}
                                                                        rightIcon={
                                                                            <ZenToolTip
                                                                                content={
                                                                                    <ZenText
                                                                                        content="An alphanumeric code that identifies a product and helps you track inventory for the store."
                                                                                        size={theme?.badgeFontSize}
                                                                                        color={theme?.dark}
                                                                                    />
                                                                                }
                                                                                height={70}
                                                                                popover={
                                                                                    <Pressable>
                                                                                        <ZenIcon
                                                                                            name="exclamationcircle"
                                                                                            type="antdesign"
                                                                                            size={14}
                                                                                            color={theme?.primary}
                                                                                            style={{ marginLeft: -12 }}
                                                                                        />
                                                                                    </Pressable>
                                                                                }
                                                                                width={280}
                                                                                backgroundColor={theme?.lightDark}
                                                                                popoverStyle={{ elevation: 4, bottom: 10 }}
                                                                            />
                                                                        }
                                                                    />
                                                                    <ZenInput
                                                                        type="outlined"
                                                                        label="UPC / Barcode"
                                                                        disabled={!isProductWrite}
                                                                        labelStyle={theme.addEditProductStyle.labelStyle}
                                                                        keyboardType="numeric"
                                                                        value={formik?.values.varCombinations[item]?.UPC}
                                                                        onChangeText={(text: string) => { formik.setFieldValue(`varCombinations.${item}.UPC`, text) }}
                                                                        onBlur={() => {
                                                                            formik.setFieldTouched('UPC', true)
                                                                            formik.setFieldValue('UPC', formik?.values.varCombinations[item]?.UPC?.trim())
                                                                        }}
                                                                        inputContainerStyle={{ height: 45 }}
                                                                    />
                                                                </View> */}
                                                                <View style={{ flex: 0.5 }}>
                                                                    <ProductBarcodeGenerator
                                                                        sku={formik?.values.varCombinations[item]?.SKU!}
                                                                        upc={formik?.values.varCombinations[item]?.UPC}
                                                                        productName={`${formik?.values.ProductName || 'Product'} - ${item}`}
                                                                        variantName={item}
                                                                        categoryName={skuCategoryName}
                                                                        brandName={skuBrandName}
                                                                        disabled={!isProductWrite}
                                                                        readOnly={Boolean(formik?.initialValues?.varCombinations?.[item]?.SKU?.trim())}
                                                                        onSkuChange={(newSku: string) => {
                                                                            setSku(newSku.trim())
                                                                            formik.setFieldValue(`varCombinations.${item}.SKU`, newSku.trim())
                                                                            formik.setFieldTouched(`varCombinations.${item}.SKU`, true)
                                                                        }}
                                                                    />

                                                                    <ZenInput
                                                                        type="outlined"
                                                                        label="UPC / Barcode"
                                                                        disabled={!isProductWrite}
                                                                        labelStyle={theme.addEditProductStyle.labelStyle}
                                                                        keyboardType="numeric"
                                                                        value={formik?.values.varCombinations[item]?.UPC}
                                                                        onChangeText={(text: string) => {
                                                                            formik.setFieldValue(`varCombinations.${item}.UPC`, text);
                                                                        }}
                                                                        onBlur={() => {
                                                                            formik.setFieldTouched(`varCombinations.${item}.UPC`, true);
                                                                            formik.setFieldValue(`varCombinations.${item}.UPC`, formik?.values.varCombinations[item]?.UPC?.trim() || '');
                                                                        }}
                                                                        inputContainerStyle={{ height: 45 }}
                                                                    />
                                                                </View>
                                                            </View>
                                                            <View style={[theme.addEditProductStyle.variantFlexdirection, { columnGap: 15, flex: 1, flexDirection: width > 600 ? 'row' : 'column' }]}>
                                                                <ZenInput
                                                                    type="outlined"
                                                                    label="Selling Price *"
                                                                    disabled={!isProductWrite}
                                                                    errorStyle={theme.addEditProductStyle.errorStyle}
                                                                    labelStyle={theme.addEditProductStyle.labelStyle}
                                                                    keyboardType='numeric'
                                                                    value={String(formik?.values.varCombinations[item]?.sellingPrice)}
                                                                    onChangeText={(text: string) => {
                                                                        formik?.setFieldTouched(`varCombinations.${item}.MRP`, true)
                                                                        formik.setFieldTouched(`varCombinations.${item}.WholesalePrice`, true)
                                                                        formik.setFieldValue(`varCombinations.${item}.sellingPrice`, text)
                                                                    }}
                                                                    onBlur={formik.handleBlur('sellingPrice')}
                                                                    errorMessage={
                                                                        formik?.touched.varCombinations?.[item]?.sellingPrice && formik?.errors?.varCombinations?.[item]?.sellingPrice
                                                                            ? formik?.touched.varCombinations[item]?.sellingPrice && formik?.errors?.varCombinations[item]?.sellingPrice
                                                                            : undefined
                                                                    }
                                                                    rightIcon={
                                                                        (formik?.values.varCombinations[item]?.sellingPrice != '' && (Number(formik?.values.varCombinations[item]?.sellingPrice) > 0) && (Math.round(((Number(formik?.values.varCombinations[item]?.MRP) - Number(formik?.values.varCombinations[item]?.sellingPrice)) / Number(formik?.values.varCombinations[item]?.MRP)) * 100) > 0 && Math.round(((Number(formik?.values.varCombinations[item]?.MRP) - Number(formik?.values.varCombinations[item]?.sellingPrice)) / Number(formik?.values.varCombinations[item]?.MRP)) * 100) <= 100)) ?
                                                                            <View style={theme.addEditProductStyle.rightIcon}>
                                                                                <ZenText content={Math.round(((Number(formik?.values.varCombinations[item]?.MRP) - Number(formik?.values.varCombinations[item]?.sellingPrice)) / Number(formik?.values.varCombinations[item]?.MRP)) * 100) + '% OFF'} color={theme.secondary} bold size={theme.smallerFontSize} style={{ color: theme.secondary, fontFamily: theme.bold, fontSize: theme.smallerFontSize }} />
                                                                            </View> : undefined
                                                                    }
                                                                    inputContainerStyle={{ height: 45 }}
                                                                    containerStyle={{ flex: 0.5 }}
                                                                />
                                                                <ZenInput
                                                                    type="outlined"
                                                                    label="MRP"
                                                                    disabled={!isProductWrite}
                                                                    labelStyle={theme.addEditProductStyle.labelStyle}
                                                                    value={String(formik?.values.varCombinations[item]?.MRP)}
                                                                    onChangeText={formik.handleChange(`varCombinations.${item}.MRP`)}
                                                                    onBlur={formik.handleBlur(`varCombinations.${item}.MRP`)}
                                                                    errorMessage={
                                                                        formik?.touched.varCombinations?.[item]?.MRP && formik?.errors.varCombinations?.[item]?.MRP
                                                                            ? formik?.touched.varCombinations?.[item]?.MRP && formik?.errors.varCombinations?.[item]?.MRP
                                                                            : undefined
                                                                    }
                                                                    rightIcon={
                                                                        <ZenToolTip
                                                                            content={
                                                                                <ZenText
                                                                                    content="To show an offer price for this product, move the Product's original price into MRP and enter a lower-price value in Selling Price."
                                                                                    size={theme?.badgeFontSize}
                                                                                    color={theme?.dark}
                                                                                />
                                                                            }
                                                                            height={70}
                                                                            popover={
                                                                                <Pressable>
                                                                                    <ZenIcon
                                                                                        name="exclamationcircle"
                                                                                        type="antdesign"
                                                                                        size={14}
                                                                                        color={theme?.primary}
                                                                                        style={{ marginLeft: -12 }}
                                                                                    />
                                                                                </Pressable>
                                                                            }
                                                                            width={280}
                                                                            backgroundColor={theme?.lightDark}
                                                                            popoverStyle={{ elevation: 4, bottom: 10 }}
                                                                        />
                                                                    }
                                                                    keyboardType="numeric"
                                                                    inputContainerStyle={{ height: 45 }}
                                                                    containerStyle={{ flex: 0.5 }}

                                                                />
                                                            </View>
                                                            <View style={[theme.addEditProductStyle.variantFlexdirection, { columnGap: 15, flex: 1, flexDirection: width > 600 ? 'row' : 'column' }]}>
                                                                <ZenInput
                                                                    type="outlined"
                                                                    label="Cost Price*"
                                                                    keyboardType='numeric'
                                                                    disabled={!isProductWrite}
                                                                    value={String(formik?.values.varCombinations[item]?.costPrice)}
                                                                    onChangeText={formik.handleChange(`varCombinations.${item}.costPrice`)}
                                                                    onBlur={formik.handleBlur(`varCombinations.${item}.costPrice`)}
                                                                    errorMessage={
                                                                        formik?.touched.varCombinations?.[item]?.costPrice && formik?.errors.varCombinations?.[item]?.costPrice
                                                                            ? formik?.touched.varCombinations?.[item]?.costPrice && formik?.errors.varCombinations?.[item]?.costPrice
                                                                            : undefined
                                                                    }
                                                                    errorStyle={theme.addEditProductStyle.errorStyle}
                                                                    rightIcon={
                                                                        <ZenToolTip
                                                                            content={
                                                                                <ZenText
                                                                                    content="Cost price of the item.This will not be available to the customers."
                                                                                    size={theme?.badgeFontSize}
                                                                                    color={theme?.dark}
                                                                                />
                                                                            }
                                                                            height={70}
                                                                            popover={
                                                                                <Pressable>
                                                                                    <ZenIcon
                                                                                        name="exclamationcircle"
                                                                                        type="antdesign"
                                                                                        size={14}
                                                                                        color={theme?.primary}
                                                                                        style={{ marginLeft: -12 }}
                                                                                    />
                                                                                </Pressable>
                                                                            }
                                                                            width={280}
                                                                            backgroundColor={theme?.lightDark}
                                                                            popoverStyle={{ elevation: 4, bottom: 10 }}
                                                                        />
                                                                    }
                                                                    containerStyle={{ flex: 0.5 }}
                                                                    inputContainerStyle={{ height: 45 }}
                                                                    labelStyle={theme.addEditProductStyle.labelStyle}

                                                                />
                                                                <ZenInput
                                                                    type="outlined"
                                                                    label="Custom Label"
                                                                    disabled={!isProductWrite}
                                                                    labelStyle={theme.addEditProductStyle.labelStyle}
                                                                    value={formik?.values.varCombinations?.[item]?.CustomLabel}
                                                                    onChangeText={(text: string) => { formik.setFieldValue(`varCombinations.${item}.CustomLabel`, text) }}
                                                                    onBlur={() => {
                                                                        formik.setFieldTouched(`varCombinations.${item}.CustomLabel`, true)
                                                                        formik.setFieldValue(`varCombinations.${item}.CustomLabel`, formik?.values.varCombinations?.[item]?.CustomLabel?.trim())
                                                                    }}
                                                                    errorMessage={
                                                                        formik?.touched.varCombinations?.[item]?.CustomLabel && formik?.errors.varCombinations?.[item]?.CustomLabel
                                                                            ? formik?.touched.varCombinations?.[item]?.CustomLabel && formik?.errors.varCombinations?.[item]?.CustomLabel
                                                                            : undefined
                                                                    }
                                                                    errorStyle={theme.addEditProductStyle.errorStyle}
                                                                    containerStyle={{ flex: 0.5 }}
                                                                    inputContainerStyle={{ height: 45 }}

                                                                />
                                                            </View>
                                                            <View style={[theme.addEditProductStyle.variantFlexdirection, { columnGap: 15, flex: 1, flexDirection: width > 600 ? 'row' : 'column' }]}>
                                                                <ZenInput
                                                                    type="outlined"
                                                                    label="Wholesale Price"
                                                                    disabled={!isProductWrite}
                                                                    labelStyle={theme.addEditProductStyle.labelStyle}
                                                                    containerStyle={{ flex: 0.5, }}
                                                                    keyboardType='numeric'
                                                                    value={String(formik?.values.varCombinations?.[item]?.WholesalePrice)}
                                                                    onChangeText={formik.handleChange(`varCombinations.${item}.WholesalePrice`)}
                                                                    onBlur={formik.handleBlur(`varCombinations.${item}.WholesalePrice`)}
                                                                    errorMessage={
                                                                        formik?.touched.varCombinations?.[item]?.WholesalePrice && formik?.errors.varCombinations?.[item]?.WholesalePrice
                                                                            ? formik?.touched.varCombinations?.[item]?.WholesalePrice && formik?.errors.varCombinations?.[item]?.WholesalePrice
                                                                            : undefined
                                                                    }
                                                                    errorStyle={theme.addEditProductStyle.errorStyle}
                                                                    inputContainerStyle={{ height: 45 }}
                                                                />
                                                                <ZenInput
                                                                    type="outlined"
                                                                    label="Square POS UUID"
                                                                    disabled={!isProductWrite}
                                                                    labelStyle={theme.addEditProductStyle.labelStyle}
                                                                    value={formik.values.varCombinations?.[item]?.SquareId}
                                                                    onChangeText={(text: string) => { formik.setFieldValue(`varCombinations.${item}.SquareId`, text) }}
                                                                    onBlur={() => {
                                                                        formik.setFieldTouched(`varCombinations.${item}.SquareId`, true)
                                                                        formik.setFieldValue(`varCombinations.${item}.SquareId`, formik.values.varCombinations?.[item]?.SquareId?.trim())
                                                                    }}
                                                                    containerStyle={{ flex: 0.5 }}
                                                                    inputContainerStyle={{ height: 45 }}

                                                                />
                                                            </View>
                                                            <View style={[theme.addEditProductStyle.variantFlexdirection, { flex: 1, columnGap: 15, flexDirection: width > 600 ? 'row' : 'column' }]}>
                                                                <ZenInput
                                                                    type="outlined"
                                                                    label="Weight"
                                                                    disabled={!isProductWrite}
                                                                    labelStyle={theme.addEditProductStyle.labelStyle}
                                                                    containerStyle={{ flex: 0.5 }}
                                                                    inputContainerStyle={{ height: 45 }}
                                                                    onChangeText={(text: string) => { formik.setFieldValue(`varCombinations.${item}.selectedWunit`, text) }}
                                                                    onBlur={() => {
                                                                        formik.setFieldTouched(`varCombinations.${item}.selectedWunit`, true)
                                                                        formik.setFieldValue(`varCombinations.${item}.selectedWunit`, formik.values.varCombinations?.[item]?.selectedWunit?.trim())
                                                                    }}
                                                                    errorMessage={
                                                                        formik.touched.varCombinations?.[item]?.selectedWunit && formik.errors.varCombinations?.[item]?.selectedWunit
                                                                            ? formik.touched.varCombinations?.[item]?.selectedWunit && formik.errors.varCombinations?.[item]?.selectedWunit
                                                                            : undefined
                                                                    }
                                                                    errorStyle={theme.addEditProductStyle.errorStyle}
                                                                    value={formik.values.varCombinations?.[item]?.selectedWunit}

                                                                />
                                                                <View style={{ flex: 0.5 }}>

                                                                    <ZenDropdown
                                                                        items={dimensionOptions}
                                                                        searchable
                                                                        disabled={!isProductWrite}
                                                                        placeholder=''
                                                                        autoScroll
                                                                        title="Dimension"
                                                                        setValue={() => { }}
                                                                        onPress={() => formik.setFieldTouched(`varCombinations.${item}.selectedDunit`, true)}
                                                                        onSelectItem={(data) => {
                                                                            formik.setFieldValue(`varCombinations.${item}.selectedDunit`, data?.value)
                                                                        }}
                                                                        open={formik.values.varCombinations?.[item]?.dimensionOpen}
                                                                        setOpen={(isOpen: any) => {
                                                                            formik?.setFieldValue(`varCombinations.${item}.dimensionOpen`, isOpen)
                                                                        }}
                                                                        mainContainerStyle={{ flex: 0.5, }}
                                                                        value={formik.values.varCombinations?.[item]?.selectedDunit}
                                                                        multiple={false}
                                                                        maxHeight={120}
                                                                        style={{
                                                                            height: 40,
                                                                        }}
                                                                        listItemLabelStyle={{
                                                                            fontSize: theme?.smallerFontSize,
                                                                        }}
                                                                        labelStyle={{
                                                                            fontSize: theme?.smallerFontSize,
                                                                            color: theme?.dark,
                                                                            fontFamily: theme?.medium,
                                                                        }}
                                                                    />
                                                                </View>
                                                            </View>

                                                            {/* Availability Location */}
                                                            < View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20 }}>
                                                                <ZenText content="Availability Location" color={theme.primary} bold={true} style={[{ top: 10, fontSize: theme?.mediumFontSize }, Platform.OS === 'web' && theme?.addEditProductStyle.webRowHeadingText]} />
                                                                {isProductWrite && <ZenButton
                                                                    title="+ Add location"
                                                                    titleStyle={{ fontSize: 14, }}
                                                                    buttonStyle={{ backgroundColor: theme?.primary, width: width < 600 ? 150 : undefined }}
                                                                    roundedSize={'md'}
                                                                    onPress={() => {
                                                                        let empty = false
                                                                        formik.values?.varCombinations?.[item]?.locArr?.map((loc) => {
                                                                            if ((loc?.selectedLoc)?.length == 0 || loc.stock == "") {
                                                                                empty = true
                                                                            }
                                                                        })
                                                                        if (empty == false) {
                                                                            if (formik.values?.varCombinations?.[item]?.locArr?.length! < locationOptions.length) {
                                                                                addLocation(item, index)
                                                                            }
                                                                            else {
                                                                                ZenToast({ message: "All the locations are already available", type: "error" })
                                                                            }
                                                                        }
                                                                        else {
                                                                            ZenToast({ message: "Please Fill the previous location details", type: "error" })
                                                                        }
                                                                    }}
                                                                />}
                                                            </View>

                                                            {formik.values?.varCombinations?.[item]?.locArr?.map((locaItem, index) => (
                                                                <View key={index} style={[theme.addEditProductStyle.locView, {
                                                                    marginBottom: ((formik?.values?.varCombinations?.[item]?.locArr?.length! - 1) == index) ? 0 : 15
                                                                }]}>
                                                                    <View style={{ marginBottom: 5 }} >
                                                                        <View style={{ flex: 1, paddingHorizontal: 10 }}>
                                                                            <View style={[theme.addEditProductStyle.locSubView, { marginBottom: 5 }]}>
                                                                                <ZenText content="Location *" size={theme?.smallerFontSize} bold color={theme.labelColor} style={Platform.OS === 'web' && theme?.addEditProductStyle.webFieldLabel} />
                                                                                {isProductWrite && formik.values?.varCombinations?.[item]?.locArr?.length! > 1 && <ZenIcon type='material-community' name='delete-outline' size={25} color={theme.darkRed} onPress={() => {
                                                                                    if (formik.values?.varCombinations?.[item]?.locArr?.length! > 1) {
                                                                                        removeLocation(item, index)
                                                                                    }
                                                                                    else {
                                                                                        ZenToast({ message: "Atleast have one location value", type: "error" })
                                                                                    }
                                                                                }} />}
                                                                            </View>
                                                                            <ZenDropdown
                                                                                setValue={() => { }}
                                                                                setOpen={() => { }}
                                                                                disabled={!isProductWrite}
                                                                                searchable
                                                                                dropdownDirection="BOTTOM"
                                                                                maxHeight={150}
                                                                                items={locationOptions}
                                                                                autoScroll
                                                                                value={locaItem?.selectedLoc!}
                                                                                dropDownContainerStyle={locaItem?.isInfinite ? theme?.addEditProductStyle.dropDownContainer : {}}
                                                                                onSelectItem={(selected) => {
                                                                                    let duplicate = false

                                                                                    if (!(locaItem?.selectedLoc == selected.value)) {
                                                                                        formik.values?.varCombinations?.[item]?.locArr?.map((selLoc) => {
                                                                                            if (selLoc.selectedLoc == selected.value) {
                                                                                                duplicate = true
                                                                                            }
                                                                                        })
                                                                                        if (!duplicate) {
                                                                                            let temp = [...(formik.values?.varCombinations?.[item]?.locArr ?? [])];
                                                                                            temp[index].selectedLoc = selected.value as string
                                                                                            temp[index].locationOpen = false
                                                                                            formik.setFieldValue(`varCombinations.${item}.locArr`, temp);
                                                                                        }
                                                                                        else {
                                                                                            let temp = [...(formik.values?.varCombinations?.[item]?.locArr ?? [])];
                                                                                            temp[index].locationOpen = false
                                                                                            formik.setFieldValue(`varCombinations.${item}.locArr`, temp);
                                                                                            ZenToast({ message: "Location already exists!", type: "error" })
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        let temp = [...(formik.values?.varCombinations?.[item]?.locArr ?? [])];
                                                                                        temp[index].locationOpen = false
                                                                                        formik.setFieldValue(`varCombinations.${item}.locArr`, temp);
                                                                                    }
                                                                                }}
                                                                                placeholder={(locaItem?.selectedLoc)?.length == 0 ? '' : locationOptions?.find(data => data.value == locaItem?.selectedLoc)?.label}
                                                                                open={locaItem?.locationOpen!}
                                                                                onPress={() => {
                                                                                    let temp = [...(formik.values?.varCombinations?.[item]?.locArr ?? [])];
                                                                                    temp[index].locationOpen = !temp[index].locationOpen
                                                                                    formik.setFieldValue(`varCombinations.${item}.locArr`, temp);
                                                                                }}
                                                                                style={{
                                                                                    height: 40,
                                                                                }}
                                                                                listItemLabelStyle={{
                                                                                    fontSize: theme?.smallerFontSize,
                                                                                }}
                                                                                labelStyle={{
                                                                                    fontSize: theme?.smallerFontSize,
                                                                                    color: theme?.dark,
                                                                                    fontFamily: theme?.medium,
                                                                                }}
                                                                            />
                                                                            {locaItem?.selectedLoc?.length == 0 ? (
                                                                                <ZenText content="Location is required" size={theme?.errorFontSize} color={theme.red} />
                                                                            ) : null}
                                                                        </View>
                                                                        <View style={{ flex: 1, marginTop: 20, paddingHorizontal: 10 }}>
                                                                            <ZenInput
                                                                                type='outlined'
                                                                                keyboardType="numeric"
                                                                                disabled={!isProductWrite}
                                                                                label="Stock *"
                                                                                labelStyle={[theme.addEditProductStyle.labelStyle, { fontSize: theme?.smallerFontSize }]}
                                                                                value={locaItem?.stock}
                                                                                onChangeText={(text: string) => {
                                                                                    let temp = [...(formik.values?.varCombinations?.[item]?.locArr ?? [])];
                                                                                    temp[index].stock = text
                                                                                    formik.setFieldValue(`varCombinations.${item}.locArr`, temp);
                                                                                }}
                                                                                inputContainerStyle={{ height: 45 }}
                                                                                errorMessage={(locaItem?.stock == '' || locaItem?.stock.indexOf('.') != -1 || locaItem?.stock.indexOf(' ') != -1 || parseInt(locaItem?.stock) > 999999 || parseInt(locaItem?.stock) < 0 || !locaItem?.stock?.match(/^\d+(\.\d{1,2})?$/)) ? locaItem?.stock == '' ? 'Limited stock is required.' : !locaItem?.stock?.match(/^\d+(\.\d{1,2})?$/) ? 'Limited stock is invalid' :
                                                                                    (parseInt(locaItem?.stock) > 100000 ? 'Limited stock should not exceed 1,00,000.' :
                                                                                        (parseInt(locaItem?.stock) < 0 ? 'Limited stock should be greater than or equal to Zero' : '')) : "  "}
                                                                            />

                                                                        </View>
                                                                        <View style={{ flex: 1, marginTop: 20, paddingHorizontal: 10 }}>
                                                                            <ZenInput
                                                                                type='outlined'
                                                                                keyboardType="numeric"
                                                                                disabled={!isProductWrite}
                                                                                label="Low stock threshold value *"
                                                                                value={locaItem?.threshold}
                                                                                onChangeText={(text) => {
                                                                                    let temp = [...(formik.values?.varCombinations?.[item]?.locArr ?? [])];
                                                                                    temp[index].threshold = text
                                                                                    formik.setFieldValue(`varCombinations.${item}.locArr`, temp);
                                                                                }}
                                                                                errorMessage={(locaItem?.threshold == '' || locaItem?.threshold.indexOf('.') != -1 || locaItem?.threshold.indexOf(' ') != -1 || parseInt(locaItem?.threshold) > 999999 || parseInt(locaItem?.threshold) <= 0) ?
                                                                                    locaItem?.threshold == '' ? 'Low stock threshold value is required.' : !locaItem?.threshold?.match(/^\d+(\.\d{1,2})?$/) ? 'Low stock threshold is invalid' :
                                                                                        (parseInt(locaItem?.threshold) > 100000 ? 'Low stock threshold value should not exceed 1,00,000.' :
                                                                                            (parseInt(locaItem?.threshold) <= 0 ? 'Low stock threshold value should be greater than Zero' : '')) : ""
                                                                                }
                                                                                inputContainerStyle={{ height: 45 }}
                                                                                labelStyle={theme.addEditProductStyle.labelStyle}
                                                                            />
                                                                        </View>
                                                                    </View>

                                                                </View>
                                                            ))}
                                                        </View>
                                                    </View>
                                                    {/* Confirmation Dialog view for leaving the page*/}
                                                    <Popover
                                                        isVisible={isLeavePopover}
                                                        popoverStyle={{
                                                            width: width > 900 ? 600 : width > 600 ? 500 : 300,
                                                            borderRadius: 10,
                                                        }}>
                                                        <CommonDialogBox
                                                            type='EDIT'
                                                            replaceValue='page'
                                                            confirmation={confirmation}
                                                        />
                                                    </Popover>
                                                </KeyboardAvoidingView>
                                            }

                                        </View>
                                    ))
                                ) : (
                                    <View style={{ justifyContent: 'center', alignItems: 'center', flex: 1, paddingHorizontal: 10, backgroundColor: theme.lightBackgroundColor }}>
                                        <Image source={require('../../../../assets/novariant.png')} style={{ width: width > 900 ? 280 : width > 600 ? 350 : 150, height: width > 900 ? 250 : width > 600 ? 300 : 130, }} />
                                        <ZenText style={{ textAlign: 'center', marginTop: 10, fontSize: theme?.smallHeaderFontSize }} content={`No variants. Please choose the " Add variant(s) to this product" in General tab to add variant(s) for the product.`} />
                                    </View>
                                )
                            }
                            <CommonImageUpload
                                bottomRef={bottomRef} propFn={handleImage}
                                gallery={{ isStoreGallery: true, sectionName: "products", screenName: "products", }}
                                selectedIndex={{ value: { imagesMaxLength: (formik?.values?.varCombinations?.[current]?.varImages?.length ? (5 - formik?.values?.varCombinations?.[current]?.varImages?.length) : 5) } }}
                            />
                        </ScrollView>
                    </View>) : <View style={{ justifyContent: 'center', alignItems: 'center', flex: 1, paddingHorizontal: 10, backgroundColor: theme.lightBackgroundColor }}>
                        <Image source={require('../../../../assets/novariant.png')} style={{ width: width > 900 ? 280 : width > 600 ? 350 : 150, height: width > 900 ? 250 : width > 600 ? 300 : 130, }} />
                        <ZenText style={{ textAlign: 'center', marginTop: 10, fontSize: theme?.smallHeaderFontSize }} content={`No variants. Please choose the " Add variant(s) to this product" in General tab to add variant(s) for the product.`} />
                    </View>}
                    <CustomModal visible={openChoseVariants} transparent={true}>
                        <View style={{ flex: 1, backgroundColor: theme.transparentBackground, justifyContent: 'center', alignItems: 'center' }}>
                            <View style={{ width: width > 600 ? 500 : 400, height: 500, backgroundColor: theme.light, borderRadius: 16 }}>
                                <View style={{ backgroundColor: theme.lightBackgroundColor, borderTopLeftRadius: 16, borderTopRightRadius: 16 }}>
                                    <View style={{ flexDirection: "row", justifyContent: "space-between", height: 30, marginHorizontal: 20, marginVertical: 20 }}>
                                        <ZenText content={"Choose Variants Combinations"} style={{ alignItems: 'flex-start', fontSize: theme?.largerFontSize, fontFamily: theme.bold, color: theme.lightDark }} />
                                        <ZenIcon type='material-community' name='close-circle' onPress={() => {
                                            setChecked(prev => {
                                                let temp = [...prev]
                                                temp?.map(i => {
                                                    Object.values(i)[0].checked = formik.values?.varCombinations?.hasOwnProperty(Object.keys(i)[0])
                                                })
                                                return temp
                                            })
                                            setOpenChoseVariants(false)
                                        }} />
                                    </View>
                                </View>
                                <View style={theme.addEditProductStyle.flex}>

                                    <VirtualizedList
                                        data={checked ?? []}
                                        renderItem={renderItem as any}
                                        showsVerticalScrollIndicator={false}
                                        getItemCount={(data) => data.length}
                                        getItem={(data, index) => {
                                            let items = [];
                                            let numColumns = 1;
                                            for (let i = 0; i < numColumns; i++) {
                                                const item = data[index * numColumns + i];
                                                item && items.push(item)
                                            }
                                            return items
                                        }}
                                        keyExtractor={(item, index) => index.toString()}
                                        ListEmptyComponent={
                                            <View style={{ justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                                                <ZenText content="No records found" style={{ fontSize: theme?.smallHeaderFontSize, color: theme?.lightDark, fontFamily: theme?.bold }} />
                                            </View>
                                        }
                                    />
                                </View>
                                <ZenDivider />
                                {isProductWrite && <View style={{ alignSelf: "flex-end", flexDirection: 'row', marginVertical: 20, marginHorizontal: 20, justifyContent: "space-between" }}>
                                    <ZenButton
                                        title='Save'
                                        buttonStyle={{ width: 100, height: width > 600 ? 50 : 40, borderRadius: 7, backgroundColor: theme.primary, borderColor: theme.primary, marginLeft: 10 }} titleStyle={[theme.addEditProductStyle.titleStyle, { color: theme.light }]}
                                        onPress={() => addCombo()}
                                    />
                                </View>}
                            </View>
                        </View>
                    </CustomModal>

                    {/* Modify Variant */}
                    <Popover
                        isVisible={isModifyPopover}
                        popoverStyle={{
                            width: width > 900 ? 600 : width > 600 ? 500 : 300,
                            borderRadius: 10,

                        }}>
                        <CommonDialogBox
                            type='OTHER'
                            dialog={varModifyProps}
                            confirmation={confirmation}
                        />
                    </Popover>
                    {/* Delete Variant */}
                    <Popover
                        isVisible={isDelVar}
                        popoverStyle={{
                            width: width > 900 ? 600 : width > 600 ? 500 : 300,
                            borderRadius: 10,

                        }}>
                        <CommonDialogBox
                            type='OTHER'
                            dialog={delVarProps}
                            confirmation={confirmation}
                        />
                    </Popover>
                </KeyboardAvoidingView>

            )}
        </ThemeConsumer>
    )
}

export default ProductVariant


